module.exports = __webpack_public_path__ + "static/media/yelp.baf72614.svg";